import Interval from './interval';

export default Interval;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/components/Interval/index.js